import React, { Component } from 'react'
import App from './containers/App/App'
import config from './config/config'

export default class Demo extends Component {
  render() {
    return <App config={config} />
  }
}
